module.exports = __webpack_public_path__ + "static/media/16_l_lamp_25.89_1.2.bd74429d.png";